import { SET_CAN_I_AUTOPLAY_RESULT } from './Actions';

const INITIAL_STATE = {
  result: null,
};

export default function(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_CAN_I_AUTOPLAY_RESULT: {
      return {
        ...state,
        result: action.payload,
      };
    }
    default:
      return state;
  }
}
